"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _cleanToken = require("./cleanToken");
Object.keys(_cleanToken).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cleanToken[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cleanToken[key];
    }
  });
});
var _getRemainingSeconds = require("./getRemainingSeconds");
Object.keys(_getRemainingSeconds).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getRemainingSeconds[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getRemainingSeconds[key];
    }
  });
});
var _getTokenClients = require("./getTokenClients");
Object.keys(_getTokenClients).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTokenClients[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTokenClients[key];
    }
  });
});
var _PublicTokenClient = require("./PublicTokenClient");
Object.keys(_PublicTokenClient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PublicTokenClient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PublicTokenClient[key];
    }
  });
});
var _TokenFetcher = require("./TokenFetcher");
Object.keys(_TokenFetcher).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TokenFetcher[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TokenFetcher[key];
    }
  });
});
var _UserTokenClient = require("./UserTokenClient");
Object.keys(_UserTokenClient).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserTokenClient[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UserTokenClient[key];
    }
  });
});
var _validateLoggedInUserCookie = require("./validateLoggedInUserCookie");
Object.keys(_validateLoggedInUserCookie).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateLoggedInUserCookie[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateLoggedInUserCookie[key];
    }
  });
});
